import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createAction, createReducer, props, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { Equipement, IEquipement } from '../../_models/Equipment';

export const name = 'equipements';

export interface EquipmentState extends EntityState<IEquipement> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectEquipment(a: IEquipement): any {
  return a.id;
}

function sortById(a: IEquipement, b: IEquipement): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IEquipement> = createEntityAdapter<IEquipement>({
  selectId: selectEquipment,
  sortComparer: sortById,
});

const initialState: EquipmentState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadEquipmentsAction = createAction('[Equipment] Load Equipments');
export const loadEquipmentsErrorAction = createAction('[Equipment] Load Equipments Error');
export const loadEquipmentsSuccessAction = createAction('[Equipment] Load Equipments Success', props<{ payload: IEquipement[] }>());
export const setEquipmentsSuccessAction = createAction('[Equipment] Set Equipments Success', props<{ payload: IEquipement[] }>());

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadEquipmentsSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(loadEquipmentsErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(setEquipmentsSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload as IEquipement[], state);
  })
);

export function equipementReducer(state: EquipmentState | undefined, action: Action): EquipmentState {
  return reducer(state, action);
}

/* SELECTOR */
const selectEquipmentState = createFeatureSelector<EquipmentState>(name);

const isInitialized = (state: EquipmentState) => state.isInitialized;
export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllEquipments = createSelector(selectEquipmentState, (state) => {
  return state.loading
    ? undefined
    : state.ids
        .map((id: any) => new Equipement(state.entities[id]))
        .sort((a, b) => {
          if (a.nom < b.nom) {
            return -1;
          } else if (a.nom > b.nom) {
            return 1;
          } else {
            return 0;
          }
        });
});
export const selectIsEquipmentInitialized = createSelector(selectEquipmentState, isInitialized);
